import React, { Component } from "react";
import Select, { components } from "react-select";
import icon from "../../../assets/images/Icon.svg";
import { MdDeleteOutline, MdEdit } from "react-icons/md";


class NormalMultiSelect extends Component {
  handleChange = (newValue) => {
    const { isMulti, name, handleChange } = this.props;

    if (!!isMulti) {
      let body = {
        target: {
          name,
          value: [],
        },
      };

      if (!!newValue && newValue.length) {
        newValue.forEach((item) => {
          let obj = {
            value: item.value,
            label: item.label,
            name: item.name,
            mobileNumber: item.mobileNumber,
          };
          body.target.value.push(obj);
        });
      }

      handleChange(body, newValue || {});
    } else {
      let body = {
        target: {
          name,
          value: newValue ? newValue.value : "",
          label: newValue ? newValue.label : "",
          name: newValue ? newValue.name : "",
          mobileNumber: newValue ? newValue.mobileNumber : "",
        },
      };

      handleChange(body, newValue || {});
    }
  };

  handleInputChange = (newValue) => {
    let body = {
      target: {
        name: this.props.name,
        value: newValue ? newValue : "",
      },
    };
    this.props.handleinputChange && this.props.handleinputChange(body);
  };

  filterOption = (option, inputValue) => {
    if (!inputValue) return true;

    const searchInput = inputValue.toLowerCase();
    const { label, name, mobileNumber } = option.data;

    // Check if input matches label, name, or mobile number
    return (
      label?.toLowerCase().includes(searchInput) ||
      name?.toLowerCase().includes(searchInput) ||
      mobileNumber?.toLowerCase().includes(searchInput)
    );
  };

  render() {
    const {
      className = "select-form-control w-100",
      options = [],
      value = "",
      label = "",
      name = "",
      placeholder = "",
      disabled = false,
      isMulti = false,
      isClearable = false,
      isSearchable = false,
      showArrow = true,
      grayed = false,
      menuPlacement,
      notification = false,
      defaultValue,
      noOptionsMessageText = "No options",
    } = this.props;

    const DropdownIndicator = (props) => {
      return (
        components.DropdownIndicator && (
          <components.DropdownIndicator {...props}>
            <span>{!disabled && <img src={icon} alt="" />}</span>
          </components.DropdownIndicator>
        )
      );
    };

        // Custom clear indicator component
        const CustomClearIndicator = (props) => {
          return (
            <components.ClearIndicator {...props}>
               <MdDeleteOutline
            size={20}
            style={{
              color: "#fa8072",
              cursor: "pointer",
              transition: "color 0.3s",
            }}
            onMouseEnter={(e) => (e.target.style.color = "#ff0000")} 
            onMouseLeave={(e) => (e.target.style.color = "#fa8072")} 
          />
            </components.ClearIndicator>
          );
        };

    const customStyles = {
      placeholder: (base) => ({
        ...base,
        fontSize: 14,
        color: "#000",
        fontWeight: 400,
        opacity: 0.8,
      }),
      indicatorSeparator: (base) => ({
        ...base,
        display: "none",
      }),

      dropdownIndicator: (base) => ({
        ...base,
        padding: 0,
        height: "26px",
        width: "26px",
        color: "#999999",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }),
      singleValue: (base) => ({
        ...base,
        color: "#222222",
        fontSize: 16,
        fontFamily: "Helvetica",
        fontWeight: 400,
      }),
      control: (base) => ({
        ...base,
        borderRadius: 5,
        border: "1px solid #d9d9d9 !important;",
        background: grayed ? "#F1F1F1" : "transparent",
        fontSize: 14,
        cursor: "pointer",
        minHeight: window?.innerWidth <= 768 ? 45 : 48,
        paddingRight: 10,
        boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.25)",
      }),
    };

    return (
      <Select
        menuPlacement={menuPlacement}
        className={className}
        classNamePrefix="Select"
        isDisabled={disabled}
        isClearable={isClearable}
        isSearchable={isSearchable}
        name={name}
        options={options}
        onChange={this.handleChange}
        isMulti={isMulti}
        showArrow={showArrow}
        placeholder={placeholder}
        styles={customStyles}
        defaultValue={defaultValue}
        value={
          !notification
            ? Array.isArray(value) && value?.length > 0
              ? options?.filter((data) => value?.includes(data?.value))
              : options?.find((data) => data?.value === value)
            : Array.isArray(value) &&
              value?.length > 0 &&
              options?.filter((data) => value?.includes(data?.value))
        }
        components={{ DropdownIndicator,ClearIndicator: CustomClearIndicator }}
        filterOption={this.filterOption}
        noOptionsMessage={() => noOptionsMessageText}
      />
    );
  }
}

export default NormalMultiSelect;
